/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedBlurbSupportNumber_item = {
    readonly pricing: {
        readonly totalAmount: {
            readonly convertedAmounts: {
                readonly USD: number | null;
            } | null;
        } | null;
    } | null;
    readonly " $refType": "PdpSharedBlurbSupportNumber_item";
};
export type PdpSharedBlurbSupportNumber_item$data = PdpSharedBlurbSupportNumber_item;
export type PdpSharedBlurbSupportNumber_item$key = {
    readonly " $data"?: PdpSharedBlurbSupportNumber_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedBlurbSupportNumber_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedBlurbSupportNumber_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "pricing",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemPricing",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "totalAmount",
          "storageKey": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "convertedAmounts",
              "storageKey": null,
              "args": null,
              "concreteType": "ConvertedAmounts",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "USD",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '12b28625acd3c2caba723e59fe3691d1';
export default node;
